if ($('.fotorama').length) {
  $(document).ready(function() {
    const fotoramaDiv = $('.fotorama').fotorama({
      width: '100%',
      minwidth: '400',
      ratio: 800/750,
      allowfullscreen: true,
      arrows: true,
      swipe: true,
      nav: document.documentElement.clientWidth <= 755 ? 'dots' : 'thumbs'
    });
    const fotorama = fotoramaDiv.data('fotorama');

    $(document).on( "click", ".fotorama:not(.fotorama--fullscreen) .fotorama__stage__shaft .fotorama__active:not(.fotorama__stage__frame--video) img", function() {
      fotorama.show($('.fotorama__stage__frame.fotorama__active').index())
      fotorama.requestFullScreen()
    });

    fotoramaDiv.on('fotorama:showend',function (e, fotorama, extra) {
      $('.fotorama__stage__frame').removeClass('video-active-gallery');
      if ('video' in fotorama.activeFrame) {
        setTimeout(function() {
          fotorama.playVideo();
          $('.fotorama--fullscreen .fotorama__wrap').removeClass('fotorama__wrap--video');
          $('.fotorama--fullscreen .fotorama__stage__shaft .fotorama__active').addClass('video-active-gallery');
        }, 1000);
      }
    })

    fotoramaDiv.on('fotorama:fullscreenexit',function (e, fotorama, extra) {
      $('.fotorama__stage__frame').removeClass('video-active-gallery');
    })
    
    $('body').on('keyup', function (e) {
        if ($('.fotorama--fullscreen').length && e.which === 27) { // detect if it is **Esc** button
          $('.fotorama__stage__frame').removeClass('video-active-gallery');
          fotorama.cancelFullScreen()
        }
    });
  });
}